import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M14.346 6.776a4.481 4.481 0 0 1-3.056 4.402s-.132.046-.132.123v1.048a1.315 1.315 0 1 1-2.63 0V11.3a2.78 2.78 0 0 1 1.92-2.615 1.867 1.867 0 0 0 1.27-1.833 1.92 1.92 0 0 0-1.89-1.813 1.863 1.863 0 0 0-1.674 1.062 1.315 1.315 0 0 1-2.37-1.142A4.48 4.48 0 0 1 9.81 2.406h.03a4.54 4.54 0 0 1 4.505 4.37Zm-3.181 9.496a1.322 1.322 0 1 0-2.644 0 1.322 1.322 0 0 0 2.644 0Z" fill="currentColor" />' }
  })
);